var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'mb-6' : _vm.paragraph.text }},[_c('div',{staticClass:"mb-4 primary--text mt-0",class:_vm.$vuetify.breakpoint.xs ? 'text-h6': 'text-h5'},[_vm._v(_vm._s(_vm.paragraph.title))]),(_vm.paragraph.text)?_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.paragraph.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }